<h2 mat-dialog-title>
  {{ data.commentaire ? 'Modifier le commentaire' : 'Nouveau commentaire' }}
</h2>

<mat-dialog-content [formGroup]="form">


  <mat-form-field appearance="outline" class="full-width full-height">
    <mat-label>Commentaire</mat-label>
    <textarea matInput rows="5" formControlName="texte"></textarea>
  </mat-form-field>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Annuler</button>
  <button mat-raised-button color="primary" (click)="save()">Enregistrer</button>
</mat-dialog-actions>
